<section *ngIf="isLoaded" class="user-profile" [class.modal]="isModal">
  <ng-container *ngTemplateOutlet="profile"></ng-container>
  <div class="additional-info">
    <div id="profile-content" [class.is-background]="!loaded"></div>
    <div
      #navPosition
      class="tabs"
      [ngStyle]="{ top: topFromHeader + 'px' }"
      [class.stuck-shadow]="stuckState"
      [class.mobile]="deviceService.isMobile()">
      <app-user-profile-nav
        [user]="user"
        [me]="me"
        [profile]="profileInfo"
        [subjectId]="subjectId"
        [disciplineChanged]="disciplineChanged"
        (activePage)="setActivePage($event)">
      </app-user-profile-nav>
    </div>
    <div class="modal-holder" [class.loading]="!loaded">
      <ng-container *ngTemplateOutlet="modalContent"></ng-container>
    </div>
  </div>
</section>

<ng-template #profile>
  <div class="profile" [class.tablet]="deviceService.isTablet()" [class.mobile]="deviceService.isMobile()">
    <div class="profile-cover-block" [class.no-cover]="!user.cover" *ngIf="isTeacher">
      <on-ui-cover [cover]="cover"></on-ui-cover>
    </div>
    <div class="top-block" [class.student]="!isTeacher">
      <div class="avatar-cover">
        <div class="avatar-block">
          <a [routerLink]="isModal ? authorUrl : null" class="avatar-wrap">
            <on-ui-cover [cover]="avatar"></on-ui-cover>
            <div
              *ngIf="isAvailableStatistics && isAuthUser"
              class="status"
              [class.offline]="!statusOnline"
              [class.online]="statusOnline"></div>
          </a>

          <ng-template [ngIf]="isAvailableStatistics && isAuthUser">
            <span class="last-visit">
              <ng-template [ngIf]="!statusOnline" [ngIfElse]="onlineRef">
                {{ 'user-profile.was' | customLocale }} {{ lastActiveAt | dfnsFormatDistanceToNow }}
              </ng-template>
            </span>
            <ng-template #onlineRef>
              {{ 'user-profile.online-now' | customLocale }}
            </ng-template>
          </ng-template>
        </div>
        <div class="info-block">
          <a [routerLink]="isModal ? authorUrl : null" class="name-wrap">
            <h1 class="full-name">{{ fullName }}</h1>

            <ng-template [ngIf]="isTeacher && isAvailableStatistics">
              <ng-template [ngIf]="profileVerified" [ngIfElse]="noVerified">
                <app-icon class="verify-icon verify" file="status" icon="teacher-verify"></app-icon>
              </ng-template>

              <ng-template #noVerified>
                <app-icon class="verify-icon no-verify" file="status" icon="teacher-no-verify"></app-icon>
              </ng-template>
            </ng-template>
          </a>

          <div class="country-wrap">
            <ng-template [ngIf]="countryName">
              <div class="flag-wrap">
                <img *ngIf="countryFlagUrl" [src]="countryFlagUrl" [alt]="countryName" class="flag" />
              </div>

              <span class="country">({{ countryName }})</span>
            </ng-template>

            <div class="speak-wrap" *ngIf="spokenLanguagesForDisplay.length">
              <span class="speak-label">{{ 'user-profile.speak-on' | customLocale }}</span>
              <span
                *ngFor="let spoken of spokenLanguagesForDisplay; let last = last; trackBy: trackByFn"
                class="speak-label value">
                {{ spoken }} <i class="point" *ngIf="!last"></i>
              </span>
              <div class="more-subjects" [class.desktop]="deviceService.isDesktop()" *ngIf="spokenLanguages.length > 2">
                <span class="count" (click)="toggleMoreLang()">+{{ spokenLanguages.length - 2 }}</span>
                <div class="more-subjects-sub" [class.showed]="showMoreLanguages">
                  <div class="more-subjects-item" *ngFor="let spoken of spokenLanguagesOthers; trackBy: trackByFn">
                    {{ spoken }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="statistics-wrap">
            <ng-container *ngTemplateOutlet="statistics"></ng-container>
          </div>
          <div class="buttons" *ngIf="(deviceService.isMobile() || !isTeacher) && !isMe && isAvailableStatistics">
            <on-ui-button
              class="primary outline"
              [label]="isSubscribed ? 'user-profile.subscribed' : 'user-profile.subscribe'"
              [iconPosition]="isSubscribed ? 'after' : null"
              (onclick)="isSubscribed ? onOpenActionsPopup() : onToggleSubscribe()">
              <ng-template [ngIf]="isSubscribed">
                <app-icon class="chevron-down" width="12" height="8" file="chevron" icon="down"></app-icon>
              </ng-template>
            </on-ui-button>
            <div class="actions-menu" *ngIf="openActionsPopup">
              <p (click)="onToggleSubscribe()">
                {{ 'users.unsubscribe' | customLocale }}
              </p>
            </div>

            <on-ui-button class="primary" label="user-profile.send" (onclick)="onOpenChat()"> </on-ui-button>
          </div>
        </div>
      </div>

      <div *ngIf="isBrowser && !isMe" class="actions-block">
        <div class="top">
          <div class="buttons" *ngIf="!deviceService.isMobile() && !isMe && isTeacher && isAvailableStatistics">
            <on-ui-button
              class="primary outline"
              [label]="isSubscribed ? 'user-profile.subscribed' : 'user-profile.subscribe'"
              [iconPosition]="isSubscribed ? 'after' : null"
              (onclick)="isSubscribed ? onOpenActionsPopup() : onToggleSubscribe()">
              <ng-template [ngIf]="isSubscribed">
                <app-icon class="chevron-down" width="12" height="8" file="chevron" icon="down"></app-icon>
              </ng-template>
            </on-ui-button>
            <div class="actions-menu" *ngIf="openActionsPopup">
              <p (click)="onToggleSubscribe()">{{ 'users.unsubscribe' | customLocale }}</p>
            </div>

            <on-ui-button class="primary" label="user-profile.send" (onclick)="onOpenChat()"> </on-ui-button>
          </div>

          <app-bookmark class="tools-item" [item]="user"></app-bookmark>

          <div class="tools-item" *ngIf="isAvailableStatistics">
            <on-ui-card-menu>
              <a class="menu-item warn" *ngIf="user.purl" [href]="user.purl">[⚠️] Panel</a>
              <ng-template [ngIf]="isSubscribed">
                <div class="menu-item" (click)="unsubscribe()">
                  {{ 'user-profile.menu-unsubscribe' | customLocale }}
                </div>
              </ng-template>
              <ng-template [ngIf]="!isMe">
                <div class="menu-item" (click)="onOpenComplainForm()">
                  {{ 'user-profile.menu-complain' | customLocale }}
                </div>
              </ng-template>
            </on-ui-card-menu>
          </div>
        </div>
      </div>
    </div>

    <ng-template [ngIf]="isTeacher && teachingSubjects.length">
      <div class="scroll" [class.mobile-subjects]="deviceService.isMobile()">
        <div class="teaching-wrap">
          <div
            *ngFor="let teach of teachingSubjects; trackBy: trackByFn"
            class="teaching-subject-item"
            [class.active]="teach.id == subjectId"
            (click)="onNavigateToSubject(teach)">
            <span class="subject-title">{{ teach?.title | customLocale }}</span>
            <ng-template [ngIf]="teach?.category_id === subjectCategoryEnum.native_language">
              <span class="native">{{ 'teacher-card.native' | customLocale }}</span>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #modalContent>
  <app-user-profile-teaching-subpage
    *ngIf="activePage === 'teaching'"
    [selectedSubjectId]="selectedSubjectId"
    [me]="_me"
    [user]="_user"
    [userProfile]="profileInfo"
    (onChangeSubject)="onChangeSubject($event)"
    (isCloseAllModals)="closeAllModals($event)"
    (loaded)="afterLoaded($event)">
  </app-user-profile-teaching-subpage>

  <app-user-profile-classes-subpage
    *ngIf="activePage === 'classes'"
    [selectedSubjectId]="selectedSubjectId"
    (onChangeSubject)="onChangeSubject($event)"
    (isCloseAllModals)="closeAllModals($event)"
    (loaded)="afterLoaded($event)">
  </app-user-profile-classes-subpage>

  <app-user-profile-lessons-subpage
    *ngIf="activePage === 'lessons'"
    [selectedSubjectId]="selectedSubjectId"
    (onChangeSubject)="onChangeSubject($event)"
    (loaded)="afterLoaded($event)">
  </app-user-profile-lessons-subpage>

  <app-user-profile-collections-subpage *ngIf="activePage === 'collections'" (loaded)="afterLoaded($event)">
  </app-user-profile-collections-subpage>

  <app-user-profile-schools-subpage *ngIf="activePage === 'schools'" (loaded)="afterLoaded($event)">
  </app-user-profile-schools-subpage>

  <app-user-profile-publications-subpage *ngIf="activePage === 'publications'" (loaded)="afterLoaded($event)">
  </app-user-profile-publications-subpage>

  <app-user-profile-feedback-subpage *ngIf="activePage === 'feedback'" (loaded)="afterLoaded($event)">
  </app-user-profile-feedback-subpage>

  <app-user-profile-about-subpage
    *ngIf="activePage === 'about'"
    [profile]="profileInfo"
    [selectedSubjectId]="selectedSubjectId"
    [isModal]="isModal"
    (loaded)="afterLoaded($event)">
  </app-user-profile-about-subpage>
</ng-template>

<ng-template #statistics>
  <section class="stats">
    <div class="line-1">
      <div *ngFor="let item of stats; let last = last; trackBy: trackByFn" class="stat">
        <span class="stat-title">{{ item.title | customLocale }}: {{ item.value }}</span>
        <span class="point" *ngIf="!last"></span>
      </div>
    </div>

    <div class="line-2" *ngIf="isTeacher">
      <div *ngFor="let stat of statsLine2; let last = last; trackBy: trackByFn" class="stat">
        <span class="stat-title label">{{ stat.title | customLocale }}: </span>
        <ng-template class="icon-wrap" [ngIf]="stat.name === 'reviews_rating'">
          <app-icon [height]="16" [width]="16" [icon]="stat.icon" class="star-icon"></app-icon>
        </ng-template>
        <span class="stat-title" [class.review]="stat.name === 'reviews_rating'">{{ stat.value | numberRound }}</span>
        <span *ngIf="!last" class="point"></span>
      </div>
      <div class="stat" *ngIf="isAvailableStatistics">
        <span class="point"></span>
        <app-rating [stats]="user.stats" [user]="user" [label]="true"> </app-rating>
      </div>
    </div>
  </section>
</ng-template>

<app-modal
  *ngIf="openComplainForm && !deviceService.isMobile()"
  (closed)="onCloseComplainForm()"
  canClose="true"
  middle="true">
  <app-modal-body>
    <app-complaint-form [type]="'user'" (cancel)="onCloseComplainForm()"></app-complaint-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal
  *ngIf="openComplainForm && deviceService.isMobile()"
  [titleVisible]="false"
  (closed)="onCloseComplainForm()">
  <app-mobile-modal-body>
    <app-complaint-form [type]="'user'" (cancel)="onCloseComplainForm()"></app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>
